// api.js
import axios from "axios";

const api = axios.create({
    baseURL: 'https://ahbeninadmin.ahbenin.org', 
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    timeout: 30000,
});
//https://ahbeninadmin.ahbenin.org/
export default api;
